import { getCourseUnitRealisations, deleteCourseUnitRealisation } from '../api';
import suppressGlobalErrors from './suppressGlobalErrors';
import { addErrorMessageAction } from './messages';
import { isSurveyForDegreeProgram } from '../util';

export const ADD_COURSE_UNIT_REALISATIONS = 'ADD_COURSE_UNIT_REALISATIONS';
export const ADD_COURSE_UNIT_REALISATIONS_FULFILLED = 'ADD_COURSE_UNIT_REALISATIONS_FULFILLED';
export const CLEAR_COURSE_UNIT_REALISATIONS = 'CLEAR_COURSE_UNIT_REALISATIONS';
export const REMOVE_COURSE_UNIT_REALISATION = 'REMOVE_COURSE_UNIT_REALISATION';

export const addCourseUnitRealisationsAction =
  (courseUnitRealisationIds, surveyId) => suppressGlobalErrors({
    type: ADD_COURSE_UNIT_REALISATIONS,
    payload: getCourseUnitRealisations(courseUnitRealisationIds, surveyId)
  });

export const clearCourseUnitRealizationsAction = () => ({
  type: CLEAR_COURSE_UNIT_REALISATIONS
});

export const removeCourseUnitRealisationAction = (courseUnitId, surveyType, surveyId) => async (dispatch) => {
  try {
    if (isSurveyForDegreeProgram(surveyType) && surveyId) {
      await deleteCourseUnitRealisation(surveyId, courseUnitId);
    }

    dispatch({
      type: REMOVE_COURSE_UNIT_REALISATION,
      payload: courseUnitId
    });
  } catch (error) {
    dispatch(addErrorMessageAction(error));
  }
};
